import { render } from "./CancelIcon.vue?vue&type=template&id=37b538c4"
import script from "./CancelIcon.vue?vue&type=script&lang=js"
export * from "./CancelIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__